import User, { IPatchUserPayload, IPostUserPayload, WorkingHoursDeletePayload } from "app/models/user"
import WorkingHour from "app/models/workingHour"
import { IPostContractApiPayload } from "app/models/contract"
import IPostBalanceHoursCorrectionPayload from "app/models/correction"
import { Params } from "./users.reducer"

export enum Types {
  GET = "USERS_GET",
  GET_SUCCESS = "USERS_GET_SUCCESS",
  GET_FAIL = "USERS_GET_FAIL",
  GET_USER = "USER_GET",
  DELETE = "USERS_DELETE",
  DELETE_SUCCESS = "USERS_DELETE_SUCCESS",
  DELETE_FAIL = "USERS_DELETE_FAIL",
  POST = "USERS_POST",
  POST_SUCCESS = "USERS_POST_SUCCESS",
  POST_FAIL = "USERS_POST_FAIL",
  GET_BY_ID = "USER_GET_BY_ID",
  GET_BY_ID_SUCCESS = "USER_GET_BY_ID_SUCCESS",
  GET_BY_ID_FAIL = "USER_GET_BY_ID_FAIL",
  PATCH = "USERS_PATCH",
  PATCH_SUCCESS = "USERS_PATCH_SUCCESS",
  PATCH_FAIL = "USERS_PATCH_FAIL",
  GET_WORKINGHOURS_BY_ID = "USER_GET_WORKINGHOURS_BY_ID",
  GET_WORKINGHOURS_BY_ID_SUCCESS = "USER_GET_WORKINGHOURS_BY_ID_SUCCESS",
  GET_WORKINGHOURS_BY_ID_FAIL = "USER_GET_WORKINGHOURS_BY_ID_FAIL",
  DELETE_WORKINGHOURS_BY_ID = "USER_DELETE_WORKINGHOURS_BY_ID",
  DELETE_WORKINGHOURS_BY_ID_SUCCESS = "USER_DELETE_WORKINGHOURS_BY_ID_SUCCESS",
  DELETE_WORKINGHOURS_BY_ID_FAIL = "USER_DELETE_WORKINGHOURS_BY_ID_FAIL",
}

export type Action =
  | GetUsersAction
  | GetUsersSuccessAction
  | GetUsersFailAction
  | DeleteUsersByIdAction
  | DeleteUsersByIdSuccessAction
  | DeleteUsersByIdFailAction
  | PostUsersAction
  | PostUsersSuccessAction
  | PostUsersFailAction
  | GetUsersByIdAction
  | GetUsersByIdSuccessAction
  | GetUsersByIdFailAction
  | PatchUsersAction
  | PatchUsersSuccessAction
  | PatchUsersFailAction

export type GetUsersAction = {
  payload: { params?: Params }
  type: Types.GET
}

export type GetUsersSuccessAction = {
  payload: { data: User[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetUsersFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostUsersAction = {
  payload: {
    user: IPostUserPayload
    correction: IPostBalanceHoursCorrectionPayload | null
    contract: IPostContractApiPayload | null
  }
  type: Types.POST
}

export type PostUsersSuccessAction = {
  type: Types.POST_SUCCESS
}

export type PostUsersFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type DeleteUsersByIdAction = {
  payload: { id: string }
  type: Types.DELETE
}

export type DeleteUsersByIdSuccessAction = {
  type: Types.DELETE_SUCCESS
}

export type DeleteUsersByIdFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export type GetUsersByIdAction = {
  type: Types.GET_BY_ID
  payload: { id: string }
}

export type GetUsersByIdSuccessAction = {
  type: Types.GET_BY_ID_SUCCESS
  payload: { data: User | undefined }
}

export type GetUsersByIdFailAction = {
  type: Types.GET_BY_ID_FAIL
  payload: { errors: object }
}

export type PatchUsersAction = {
  type: Types.PATCH
  payload: IPatchUserPayload
}

export type PatchUsersSuccessAction = {
  type: Types.PATCH_SUCCESS
  payload: { data: User }
}

export type PatchUsersFailAction = {
  type: Types.PATCH_FAIL
  payload: { errors: object }
}

export type DeleteUserWorkingHoursByIdAction = {
  type: Types.DELETE_WORKINGHOURS_BY_ID
  payload: WorkingHoursDeletePayload
}

export type DeleteUserWorkingHoursByIdSuccessAction = {
  type: Types.DELETE_WORKINGHOURS_BY_ID_SUCCESS
  payload: { data: WorkingHour[] }
}

export type DeleteUserWorkingHoursByIdFailAction = {
  type: Types.DELETE_WORKINGHOURS_BY_ID_FAIL
  payload: { errors: object }
}

export function getUsers(params?: Params): GetUsersAction {
  return {
    payload: { params },
    type: Types.GET,
  }
}

export function getUsersSuccess(data: User[] | undefined): GetUsersSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getUsersFail(errors: object): GetUsersFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function deleteUsersById(id: string): DeleteUsersByIdAction {
  return {
    payload: { id },
    type: Types.DELETE,
  }
}

export function deleteUsersByIdSuccess(): DeleteUsersByIdSuccessAction {
  return {
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteUsersByIdFail(errors: object): DeleteUsersByIdFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}

export function postUsers(
  user: IPostUserPayload,
  correction: IPostBalanceHoursCorrectionPayload | null,
  contract: IPostContractApiPayload | null,
): PostUsersAction {
  return {
    payload: { user, correction, contract },
    type: Types.POST,
  }
}

export function postUsersSuccess(): PostUsersSuccessAction {
  return {
    type: Types.POST_SUCCESS,
  }
}

export function postUsersFail(errors: object): PostUsersFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function getUsersById(id: string): GetUsersByIdAction {
  return {
    payload: { id },
    type: Types.GET_BY_ID,
  }
}

export function getUsersByIdSuccess(data: User | undefined): GetUsersByIdSuccessAction {
  return {
    payload: { data },
    type: Types.GET_BY_ID_SUCCESS,
  }
}

export function getUsersByIdFail(errors: object): GetUsersByIdFailAction {
  return {
    payload: { errors },
    type: Types.GET_BY_ID_FAIL,
  }
}

export function patchUsers(payload: IPatchUserPayload): PatchUsersAction {
  return {
    payload,
    type: Types.PATCH,
  }
}

export function patchUsersSuccess(data: User): PatchUsersSuccessAction {
  return {
    payload: { data },
    type: Types.PATCH_SUCCESS,
  }
}

export function patchUsersFail(errors: object): PatchUsersFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}
